module.exports = function() {
  return new Worker(__webpack_public_path__ + "e131a3097e6c6104f1e2.worker.js");
};